import {
    ClearIndicatorProps,
    components,
    DropdownIndicatorProps,
    GroupHeadingProps,
    GroupProps,
    MenuListProps,
    MultiValueGenericProps,
    OptionProps,
    StylesConfig,
} from 'react-select';

import { CheckIcon, ClearIcon } from '@/components/icons/input';
import { ArrowDownIcon } from '@/components/icons/main-block';
import cn from '@/components/shared/Dropdown/styles.module.sass';
import { getCorrectMultipleWord } from '@/utils';

export const baseStyles: StylesConfig = {
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
    multiValue: styles => ({ ...styles, display: 'none' }),
    singleValue: styles => ({
        ...styles,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '16px',
        letterSpacing: -0.2,
        color: '#111827',
    }),
    multiValueRemove: styles => ({ ...styles, display: 'none' }),
    control: styles => ({
        ...styles,
        border: 'none',
        boxShadow: 'none',
        fontSize: 14,
        lineHeight: '14px',
        cursor: 'pointer',
        padding: '12px 29px 12px 10',
        backgroundColor: '#E5E7EB',
        width: 161,
    }),
    menuList: styles => ({
        ...styles,
        maxHeight: 224,
    }),
    groupHeading: styles => ({
        ...styles,
        textTransform: 'none',
        fontWeight: 600,
        color: '#111827',
        fontSize: 14,
        lineHeight: '16px',
        padding: '8px 24px',
    }),
    menu: styles => ({
        ...styles,
        width: 300,
        overflow: 'hidden',
        borderRadius: 5,
        backgroundColor: '#E5E7EB',
        zIndex: 10,
        top: 32,
    }),
    option: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: isFocused ? '#CBD5E1' : 'white',
        color: '#111827',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '16px',
        cursor: 'pointer',
        padding: '8px 24px',
    }),
};

export const DropdownIndicator = ({ hasValue }: DropdownIndicatorProps) =>
    !hasValue && <span className={cn.dropdownIcon}>{ArrowDownIcon}</span>;

export const ClearIndicator = (props: ClearIndicatorProps) => (
    <components.ClearIndicator {...props} className={cn.clearIcon}>
        <span>{ClearIcon}</span>
    </components.ClearIndicator>
);

export const Option = ({ children, ...props }: OptionProps) => (
    <components.Option {...props} className={cn.option}>
        {props.isSelected ? <span className={cn.checkIcon}>{CheckIcon}</span> : null}
        {children}
    </components.Option>
);

export const getMultiValueContainer =
    (valueName: string) =>
    ({ selectProps: { getOptionValue, value }, data }: MultiValueGenericProps) => {
        const selectedValues = value as (string | number)[];
        const isFirst = getOptionValue(data) == getOptionValue(selectedValues[0]);
        return isFirst ? (
            <span className="test">
                {selectedValues.length} {getCorrectMultipleWord(valueName, selectedValues.length)}
            </span>
        ) : null;
    };

export const MultiValueContainerRegions = getMultiValueContainer('регион');
export const MultiValueContainerTariffs = getMultiValueContainer('тариф');

export const MenuListTariffs = ({ children, ...props }: MenuListProps) => {
    return (
        <components.MenuList {...props}>
            <div className={cn.tariffsPlaceholder}>Выбрать тариф</div>
            {children}
        </components.MenuList>
    );
};

export const GroupHeadingTariffs = ({ children, ...props }: GroupHeadingProps) => {
    return (
        <components.GroupHeading {...props} className={cn.tariffsGroupHeading}>
            {children}
        </components.GroupHeading>
    );
};

export const GroupTariffs = ({ children, ...props }: GroupProps) => {
    return (
        <>
            <components.Group {...props} className={cn.groupTariffs}>
                {children}
            </components.Group>
            {}
        </>
    );
};
